// 2P AI — dashboard con barra in basso (§7). Le tre schede (Progetti/Server/Notifiche) sono stato
// interno (come la maquette): la bottom nav cambia scheda senza cambiare rotta. Default: Progetti.
import { useState } from 'react';
import { useLocation } from 'wouter';
import { CommandBar } from '../components/CommandBar';
import { BottomNav, type NavKey } from '../components/BottomNav';
import { Icon } from '../components/Icon';
import { ProjectsTab } from './ProjectsTab';
import { ServersTab } from './ServersTab';
import { NotificationsTab } from './NotificationsTab';

export function Dashboard({ initialTab = 'progetti' }: { initialTab?: NavKey } = {}) {
  const [, navigate] = useLocation();
  const [tab, setTab] = useState<NavKey>(initialTab);
  const [serverFilter, setServerFilter] = useState<string | null>(null);

  const newSession = (
    <button className="btn-primary" type="button" onClick={() => navigate('/new')}>
      <Icon name="add" /><span className="lbl">Nuova sessione</span>
    </button>
  );

  return (
    <>
      <div className="app">
        <CommandBar actions={newSession} onSettings={() => navigate('/settings')} />
        {tab === 'progetti' ? <ProjectsTab serverFilter={serverFilter} onClearFilter={() => setServerFilter(null)} /> : null}
        {tab === 'server' ? <ServersTab onOpenServer={(id) => { setServerFilter(id); setTab('progetti'); }} /> : null}
        {tab === 'notifiche' ? <NotificationsTab /> : null}
        <div className="footer">2P AI · CRM per Claude Code</div>
      </div>
      <BottomNav
        active={tab}
        badge={0}
        onNavigate={(k) => { setTab(k); if (k !== 'progetti') setServerFilter(null); }}
      />
    </>
  );
}
